import { useLayoutEffect } from 'react';

/**
 * Hook that alerts clicks outside of the passed ref
 * This hook needs to be typed with the referenced object type
 */
const useClickOutside = <T extends HTMLElement>(
  // RefObject, such as created with React.useRef<T>
  ref: React.RefObject<T>,
  // The callback to apply, using the mousedown event if needed
  callback: (event?: MouseEvent) => void
): void => {
  useLayoutEffect(() => {
    /**
     * Alert if clicked on outside of element
     */
    function handleClickOutside(event: MouseEvent): void {
      if (event.target instanceof HTMLElement && !ref.current?.contains(event.target)) {
        callback(event);
      }
    }

    // Bind the event listener
    window.addEventListener('mousedown', handleClickOutside);

    return (): void => {
      // Unbind the event listener on clean up
      window.removeEventListener('mousedown', handleClickOutside);
    };
  }, [ref, callback]);
};

export default useClickOutside;
